'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reselect = require('reselect');

var _defaults = require('../defaults');

/**
 * Gets the timezone to be used for the application
 * @param {Map<*, *>} state The application state. Defaults to the default timezone if none is set
 * @returns {string} The timezone
 */
var getTimezone = function getTimezone(state) {
  return state.getIn(['settings', 'timezone'], _defaults.DEFAULT_TIMEZONE);
};

/**
 * Get the current timezone
 * @param {Map} state The redux state
 * @return {String} The application timezone
 */

var getTimezoneSelector = (0, _reselect.createSelector)([getTimezone], function (timezone) {
  return timezone;
});

exports.default = getTimezoneSelector;
//# sourceMappingURL=timezone.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-global-settings/dist/main/selectors/timezone.js
// module id = 526
// module chunks = 0